import styles from './MobileBgPurpleBlur.module.scss'


const MobileBgPurpleBlur: React.FC = () => {
    return (
    <div className={styles.container}></div>
    )
}
export default MobileBgPurpleBlur